import angular from 'angular';
import DateUtilFactory from './date-util.factory';

let DateUtilModule = angular.module('app.date-util', [])

.factory('DateUtil', DateUtilFactory)

.name;

export default DateUtilModule;




// WEBPACK FOOTER //
// ./client/app/common/date-util/index.js